import { t } from '@framework/i18n';
import { useFormItemScreenReaderLabelAddition } from '../../item/label/useFormItemScreenReaderLabelAddition';
import { type SelectOption } from '../SelectInput';
import { useSelectedOptionLabel } from './useSelectedOptionLabel';

interface IUseSelectScreenReaderLabelAdditionProps {
  value: any;
  options: SelectOption[] | null | undefined;
  mode: 'multiple' | 'tags' | undefined;
  filterProp: string;
  readOnly: boolean | undefined;
  loading: boolean | undefined;
}

export function useSelectScreenReaderLabelAddition({
  value,
  options,
  mode,
  filterProp,
  readOnly,
  loading,
}: IUseSelectScreenReaderLabelAdditionProps) {
  const selectedLabel = useSelectedOptionLabel(
    value,
    options,
    mode,
    filterProp,
  );

  // Aggiungo un label nascosto per l'accessibilità, che indica il valore
  // selezionato e se ci sono opzioni o meno nella Select.
  const noResultsLabel =
    options != null &&
    options.length === 0 &&
    !loading &&
    t(
      'inputs.select.nessuna-opzione-disponibile',
      '(Nessuna opzione disponibile)',
    );

  // Aggiungo un label se la selezione è multipla o tags
  const multipleLabel =
    mode === 'multiple' || mode === 'tags'
      ? t('inputs.select.multipla', '(Permette selezioni multiple)')
      : undefined;

  const screenReaderLabelAddition =
    selectedLabel || noResultsLabel || multipleLabel
      ? `${selectedLabel ?? ''} ${noResultsLabel || ''} ${
          multipleLabel ?? ''
        }`.trim()
      : undefined;

  useFormItemScreenReaderLabelAddition(
    readOnly ? null : screenReaderLabelAddition,
  );
}
